export const API_BASE_URL = "https://ecom-backend-b6s5.onrender.com";
